"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = {
  description: 'Add an Agent2Agent (A2A) protocol asset that enables secure communication and collaboration between intelligent agents.',
  flows: [{
    fields: []
  }]
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map